import { Autocomplete } from '@mui/material';
import { useOldPetService } from 'service';

export default function SelectPetType({ anonymous, ...props }) {
  const { usePetTypeOpts } = useOldPetService(anonymous);
  const { data: petTypeData } = usePetTypeOpts();

  return <Autocomplete options={petTypeData || []} getOptionLabel={option => option.typeName} {...props} />;
}
